<template>
    <content-loader class="lazy_load" width="240" height="188"
        viewBox="0 0 240 188"
        :speed="2"
        primaryColor="#ebebeb"
        secondaryColor="#c9c9c9"
    >
        <rect x="0" y="0" rx="5" ry="5" width="240" height="96" /> 
        <rect x="0" y="156" rx="5" ry="5" width="240" height="32" /> 
        <rect x="0" y="106" rx="5" ry="5" width="139" height="17" /> 
        <rect x="0" y="133" rx="3" ry="3" width="81" height="5" /> 
        <rect x="0" y="141" rx="3" ry="3" width="42" height="5" />
    </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader"

export default {
    components: { ContentLoader }
}
</script>

<style>
.lazy_load{
    background: white;
}
</style>